<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>人物管理 > <b>AI大脑</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
		  <span class="search_span_width">
		    <span class="search_span_width_part1">用户ID：</span>
		  		<Input v-model="search.user_id" clearable style="width: 80px" />
		  	</span>
        <span class="search_span_width">
	         <span class="search_span_width_part1">名称：</span>
	       		<Input v-model="search.name" style="width: 130px" />
	    </span>

        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getRoleList(1)">搜索</Button>
      </Card>
      <Card>
        <p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
        </p>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="roleList"></Table>
          <Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getRoleList"/>
        </Card>
      </Card>
    </Content>
    <Modal v-model="showRecharge" :footer-hide="true" title="AI大脑">
      <Form ref="study_worlds" :model="study_info" :label-width="80">
        <FormItem label="AI大脑容量充值" prop="word_number_recharge">
          <Input v-model="study_info.word_number_recharge" placeholder="请输入字数" style="width: 200px" />
          <Button-group>
            &nbsp;<Button type="warning">剩余{{study_info.word_number}}字</Button>
          </Button-group>
        </FormItem>
        <FormItem label="学习文档" prop="study_url">
          <Upload :action="getUploaFiledUrl" :data="study_info" :headers="uploadHeader" :on-success="successStudy">
            <Button icon="ios-cloud-upload-outline">上传学习文档</Button>
          </Upload>
          <span style ="color: red">支持.docx,.txt</span>
        </FormItem>
        <FormItem>
          <Button @click="closeModal" style="margin-left: 8px">取消</Button>&nbsp;&nbsp;&nbsp;&nbsp;
          <Button type="primary" @click="updateRecharge()">提交</Button>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="studyfiguremodal" :footer-hide=true title="学习内容" :width="70">
      <Table :columns="study_figure_list" :data="study_figure_data"></Table>
    </Modal>
  </Layout>
</template>
<script>

export default {
  data(){
    return {
      search : {
        user_id:0,
        name:''
      },
      loading2: false,
      showRecharge:false,
      studyfiguremodal:false,
      recordTotal:0,
      page:1,
      loadingStatus:false,
      upLoadProgress:0,
      study_figure_data:[],
	  roleList:[],
      channel_arr:[],
      study_info:{
        figure_id:0,
        word_number_recharge:0,
        word_number:0,
        word_number_total:0,
        study_url:""
      },
      study_figure_list:[
        { title: '学习ID', key: 'id', align: 'center' },
        { title: '学习名称', key: 'study_name', align: 'center' },
        { title: '学习内容', key: 'study_content', align: 'center',
          render:(h,params) =>{
            return h('Input', {
              height:"100px",
              props: { value: params.row.study_content , type: 'textarea',style:{height:100}},
              // key:params.row.study_content,//"study_content",
              style : { width: '200px', height : '110px' ,textAlign: 'center'}
            })
          }},
        { title: '学习状态', key: 'job_status_name', align: 'center' },
      ],
      tableColumns:[
        { title: '分身ID', key: 'id', align: 'center' },
		{ title: '用户ID', key: 'user_id', align: 'center' },
        { title: '名称', key: 'name', align: 'center' ,
          render:(h,params) =>{
            return h('span',{},params.row.name+'('+params.row.sex+')');
          }
        },
        { title: '创建时间', key: 'created_at', align: 'center',
          render:(h,params) =>{
            return h('span',{},this.formatDate(params.row.created_at));
          }
		},
        { title: '学习记录', key: 'name', align: 'center',
          render: (h, params) => {
            let btns=[]
            var txt = '查看学习内容';
            btns.push(
                h('Button', {
                  props: { type: 'dashed',},
                  on: {
                    click: () => {
                      this.getstudyfigureList(params.row.id);
                      this.studyfiguremodal  = true;
                    }
                  }
                }, txt),
            );
            return h("div",btns);
          }
        },
        { title: '操作', key: 'action', align: 'center',width: 200,
          render: (h, params) => {
            let btns=[]
            btns.push(
                h('Button', {
                  props: { type: 'info', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px' },
                  on: {
                    click: () => {
                      this.study_info.figure_id =params.row.id;
                      this.study_info.word_number =0;
                      this.study_info.word_number_total =0;
                      this.getStudyWords();
                      this.showRecharge = true;
                    }
                  }
                }, 'AI大脑'),
            );
            return h("div",btns);
          }
        }
      ],
      uploadHeader:{
        "Authorization":localStorage.getItem('token')
      },
    }
  },
  mounted:function(){
    this.getRoleList();
  },
  computed:{
    getUploaFiledUrl(){
      return process.env.VUE_APP_APIHOST+'/admin/miniAi/upload';
    },
  },
  methods:{
	formatDate(timestamp) {
		// 处理秒级时间戳（若传入10位数字则转为毫秒）
		if (timestamp.toString().length === 10) {
		  timestamp *= 1000;
		}

		const date = new Date(timestamp);

		// 获取年、月、日（月从0开始，需+1）
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0'); // 补0（如5→05）
		const day = String(date.getDate()).padStart(2, '0');

		// 获取时、分、秒
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');
		const seconds = String(date.getSeconds()).padStart(2, '0');

		// 拼接为 YYYY-MM-DD HH:MM:SS 格式
		return `${year}-${month}-${day}`;
	},
    handleUpload (file) {
      this.file = file;
      return false;
    },
    getRoleList(page=this.page) {
      this.page = page;
      let p = {'page' : page}
      let params = Object.assign(this.search, p);
      this.http1.get('/figure/figureRoleList',{params:params}).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.roleList = data.data.list;
          this.recordTotal = data.data.total;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    successStudy(response, file, fileList){
      let data=response
      if(data.code!=0) {
        this.$Message.error(data.message);
        return true;
      }
      this.study_info.study_url = data.data.url;
      //alert(this.figure.study_url);
      this.$Message.success('上传成功');
    },
    getStudyWords(){
      this.http.post('/admin/figure/getFigureStudyWords',{figure_id:this.study_info.figure_id}).then(response=>{
        let data=response.data;
        //alert(JSON.stringify(data));
        if(data.code !==0) {
          this.$Message.error(data.message);
          return false;
        } else{
          if(data.data.word_number){
            this.study_info.word_number =data.data.word_number;
            this.study_info.word_number_total =data.data.word_number_total;
          }

        }
      });
    },
    updateRecharge(){
      this.http.post('/admin/figure/rechargewords',{
        'figure_id':this.study_info.figure_id,
        'word_number' : this.study_info.word_number_recharge,
        'study_url' : this.study_info.study_url,
      }).then(response=>{
        let data=response.data;
        if(data.code!==0)
        {
          this.$Message.error(data.message);
          return false;
        }
        else{
          this.$Message.info(data.message);
          this.showRecharge=false;
          return true;
        }
      });
    },
    getstudyfigureList(figure_id){//定制用户列表
      this.study_info.figure_id = figure_id;
      this.http.get('/admin/figure/getstudyfigureList',{params:{figure_id:figure_id}}).then(response=>{
        let datas=response.data;
        if(datas.code!==0) {
          this.$Message.error(datas.message);
        } else{

          // const objToStr = JSON.stringify(data.data.list)
          this.study_figure_data = datas.data.list;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    closeModal(){
      this.showRecharge = false;
    },
  }

}
</script>
<style>

img {
  width: 100%;
  display: inline-block;
}
.oss_file input {
  right: 0;
  top: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: pointer;
  width: 100%;
  height: 100%;
}
</style>